import {  createAsyncThunk  } from "@reduxjs/toolkit";
import { GET_CHAT_ROOM_MESSAGES, MY_CHATS, SEND_MESSAGE } from "../../../app/apollo";
import { apolloClient as client } from "../../../app/graphql";
import { pushChatMessage, pushTempMessage, store } from "../../../app/store";
import { IMyChats,IChatMessages, ITempMessage } from "../chat.interface";
// import {  } from "../interface";

export const getChatConversations = createAsyncThunk('chat/getChatConversation', async ()=> {
    const response = await client.query({
        query: MY_CHATS,
        fetchPolicy:"network-only"
    })
    
    if(response.data.MyChats === null) return
    return ( response.data.MyChats ) as IMyChats[]
})

export const getChatMessages = createAsyncThunk('chat/newMessage', async (chatId:number,)=> {
  
        const response = await client.query({
            query: GET_CHAT_ROOM_MESSAGES,
            variables:{
                chatroom_id: +chatId
            }
        })
    console.log(response.data.getChatRoomMessages)
    return ( response.data.getChatRoomMessages ) as IChatMessages[]
  
})

export const pushMessage = createAsyncThunk('chat/pushMessage', async (data: { chatroom_id: number | null, created_at?: any, message:string,user_id:number})=> {
   const temp_key = Date.now()
   console.log({...data,temp_key})
   
   
   if(data.chatroom_id === null) return
   store.dispatch(pushChatMessage({...data,temp_key}))
        
    try {
        console.log("is sending")
        client.mutate({
            mutation: SEND_MESSAGE,
            variables:{
            chatroom_id: +data.chatroom_id,
            message: data.message,
            }
        }).then(resp => {
            console.log(resp)
            //
        })    
    } catch (error) {
            console.log(error)
    }
    

   return ({ ...data, id: temp_key, }) as IChatMessages

})
